import React, { useState, useEffect } from "react";
import Data from "../../utils/data";
import _ from "lodash";
import {Form, Table} from "react-bootstrap";
import DeleteForever from "@material-ui/icons/DeleteForever";
import {MenuItem, Select} from "@material-ui/core";
import "../../styles/form.scss";

const languageTypes = _.map(
  [
    "Same as Source",
    "English",
    "LAS",
    "French",
    "German",
    "Castilian",
    "Portuguese",
    "Italian",
    "M+E",
    "Music",
    "Effects",
    "Dialogue",
    "Mix-Minus",
    "Announce - English",
    "Announce - Spanish",
    "Nat Sound",
    "Silence",
  ],
  Data.optionizeString
);

const channelConfigs = _.map(
  [
    "Same as Source",
    "Stereo L/R Pair",
    "Stereo Left",
    "Stereo Right",
    "Mono",
    "Left Total",
    "Right Total",
    "Left – 5.1 Discrete",
    "Right - 5.1 Discrete",
    "Center - 5.1 Discrete",
    "LFE - 5.1 Discrete",
    "Left Surround - 5.1 Discrete",
    "Right Surround - 5.1 Discrete",
  ],
  Data.optionizeString
);

const AudioLayout = ({ audioLayout, defaultValues, audioMsg, update, advanceOptions, readOnly, placeholderText }) => {
  let placeHolder = placeholderText || "Same as Source";
  const options = _.map([placeHolder].concat(_.range(1, 13)), Data.optionizeString);
  const [customAudioLayout, setCustomAudioLayout] = useState(_.keys(audioLayout).length > 1 ? audioLayout : {});
  const [channel, setChannel] = useState(_.keys(audioLayout).length > 1 ? "" + _.keys(audioLayout).length / 2 : placeHolder);

  useEffect(() => {
    update(channel, null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [channel, customAudioLayout, advanceOptions]);
  useEffect(() => {
    setChannel(_.keys(audioLayout).length > 1 ? "" + _.keys(audioLayout).length / 2 : placeHolder);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [placeholderText]);

  const handleOnChange = (e) => {
    const comp = {};
    const key = e.target.id;
    const value = e.target.value;
    comp[key] = value;
    setCustomAudioLayout(Object.assign({ ...customAudioLayout }, comp));
  };

  const renderAdditionalLayout = (channels) => {
    return (
      <Table>
          <thead>
            <tr>
                <th>Audio Layout</th>
                <th>Language/Type</th>
                <th>Channel Config</th>
            </tr>
          </thead>
        {_.times(channels, (channelName) => {
          let languageKey = "languageType" + (channelName + 1);
          let configKey = "channelConfig" + (channelName + 1);
          return (
              <tbody key={"channel" + channelName}>
              <>
                {!readOnly ? (
                  <tr>
                    <td>
                      {channelName + 1}
                    </td>
                    <td>
                      <Form.Control
                        id={languageKey}
                        as={Select}
                        className="formInputSelect"
                        classes={{
                            root: "dropdownRoot"
                        }}
                        disableUnderline={true}
                        disabled={readOnly}
                        style={{ fontSize: "14px" }}
                        defaultValue={_.get(customAudioLayout, languageKey, placeHolder)}
                        onChange={handleOnChange}
                        inputProps={{
                          id: languageKey
                        }}
                        MenuProps={{
                            anchorOrigin: {
                                vertical: "bottom",
                                horizontal: "left",
                            },
                            transformOrigin: {
                                vertical: "top",
                                horizontal: "left",
                            },
                            getContentAnchorEl: null,
                            style: {
                                zIndex: 15000
                            }
                        }}>
                        {_.map(languageTypes, (item, index) => {
                          return (
                            <MenuItem
                                className=".dropdownSelect"
                                key={channelName + "_" + index}
                                value={_.get(item, "value")}>
                              {_.get(item, "label")}
                            </MenuItem>
                          );
                        })}
                      </Form.Control>
                    </td>
                    <td>
                      <Form.Control
                        id={configKey}
                        as={Select}
                        className="formInputSelect"
                        classes={{
                            root: "dropdownRoot"
                        }}
                        disableUnderline={true}
                        disabled={readOnly}
                        defaultValue={_.get(customAudioLayout, configKey, placeHolder)}
                        onChange={handleOnChange}
                        inputProps={{
                          id: configKey
                        }}
                        MenuProps={{
                            anchorOrigin: {
                                vertical: "bottom",
                                horizontal: "left",
                            },
                            transformOrigin: {
                                vertical: "top",
                                horizontal: "left",
                            },
                            getContentAnchorEl: null,
                            style: {
                                zIndex: 15000
                            }
                        }}>
                        {_.map(channelConfigs, (item, index) => {
                          return (
                            <MenuItem
                                className="dropdownSelect"
                                key={index}
                                value={_.get(item, "value")}>
                              {_.get(item, "label")}
                            </MenuItem>
                          );
                        })}
                      </Form.Control>
                    </td>
                    <td>
                        <DeleteForever
                            style={{ fill: "#3D4553" }}
                            onClick={(e) => {
                                e.preventDefault();
                                removeChannel(channelName);
                            }}
                        />
                    </td>
                  </tr>
                ) : (
                  <tr>
                    <td>
                      {channelName + 1}
                    </td>
                    <td>{_.get(customAudioLayout, languageKey, placeHolder)}</td>
                    <td>{_.get(customAudioLayout, configKey, placeHolder)}</td>
                  </tr>
                )}
              </>
              </tbody>
          );
        })}
      </Table>
    )
  };

  const removeChannel = (channelNumber) => {
    const channelCount = parseInt(channel);

    if (channelCount === 1) {
      setChannel(placeHolder);
    } else {
      let languageKey = "languageType" + (channelNumber + 1);
      let configKey = "channelConfig" + (channelNumber + 1);

      _.times(channelCount - 1, (pos) => {
        let languageKeyPos = "languageType" + (pos + 1);
        let languageKey1 = "languageType" + (pos + 2);

        let configKeyPos = "channelConfig" + (pos + 1);
        let configKey1 = "channelConfig" + (pos + 2);

        if (pos >= channelNumber) {
          (document.getElementById(languageKeyPos) as HTMLInputElement).value = (document.getElementById(languageKey1) as HTMLInputElement).value;
          (document.getElementById(configKeyPos) as HTMLInputElement).value = (document.getElementById(configKey1) as HTMLInputElement).value;
        }
      });
      const model = {};
      model[languageKey] = null;
      model[configKey] = null;

      setChannel("" + Math.max(channelCount - 1, 1));
    }
  };

  return (
    <>
      {advanceOptions && !readOnly ? (
        <Form.Group controlId="custom_audio_layout">
          <Form.Label className="formLabel">Customize Audio Layout</Form.Label>
          <Form.Control
            as={Select}
            className="formInputSelect"
            classes={{
              root: "dropdownRoot"
            }}
            disableUnderline={true}
            onChange={(e) => {
              setChannel(e.target.value);
              if (e.target.value === "Same as Source") {
                setCustomAudioLayout({});
              }
            }}
            value={channel || ''}
            MenuProps={{
                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "left",
                },
                transformOrigin: {
                    vertical: "top",
                    horizontal: "left",
                },
                getContentAnchorEl: null,
                style: {
                    zIndex: 15000
                }
            }}>
            {_.map(options, (item, index) => {
              return (
                <MenuItem
                    key={index}
                    value={_.get(item, "value")}
                    className="dropdownSelect">
                  {_.get(item, "label")}
                </MenuItem>
              );
            })}
          </Form.Control>
        </Form.Group>
      ) : null}
      {channel !== placeHolder ? renderAdditionalLayout(channel) : null}
      {channel === placeHolder && !_.isEmpty(defaultValues) ? (
        <Form.Group controlId="description">
          <Form.Label className="formLabel">{audioMsg ? audioMsg : "Audio Layout"}</Form.Label>
          <ol style={{ padding: "0 0 0 10px" }}>
            {_.map(defaultValues, (item, idx) => {
              return (
                <li className="audioLayoutText" key={idx}>
                  {item}
                </li>
              );
            })}
          </ol>
        </Form.Group>
      ) : null}
    </>
  );
};

AudioLayout.defaultProps = {
  advanceOptions: false,
  readOnly: false,
  placeholderText: null,
};

export default React.memo(AudioLayout);
